export class MReportUser {
    id: string

    firstName: string

    middleName: string

    lastName: string

    gender: string

    email: string

    phone: string

    address: string

    constructor(user: any) {
        this.id = user?.id || ' - '
        this.firstName = user?.profile?.firstName || ' - '
        this.middleName = user?.profile?.middleName || ' - '
        this.lastName = user?.profile?.lastName
        this.gender = user?.profile?.gender || ' - '
        this.email = user?.email || ' - '
        this.phone = user?.phone || ' - '
        this.address = user?.profile?.address || ' - '
    }
}
